import React, { useRef } from "react";
import InputWrapper from "../input-wrapper/input-wrapper";
import { containsNonLatinLetters } from "../../../utils/helper-functions/sanitize-non-latin-characters";
import { useAdditionalFieldValue } from "./use-additional-field-value";

const CreateInputText = (props) => {
  const {
    input,
    errors,
    onChange,
    onFieldLoad,
    onBlur,
    onFocus,
    fields,
    required = [],
    template = {},
    cashier_theme,
    icon,
    langBack,
    s,
    onClick,
    isPixV2,
    fieldType,
    layout,
  } = props;

  const { name, label, type } = input;

  const inputEl = useRef(null);

  const { inputValue, setInputValue, readOnly } = useAdditionalFieldValue({
    input,
    fields,
    template,
    isPixV2,
  });

  const handleInputChange = (event) => {
    if (!event || !event.target) return;
    let { value, name } = event.target;
    let sanitizedValue = value;
    if (containsNonLatinLetters(value)) {
      // Regex: Allows only basic Latin letters, digits, and common punctuation
      // and removes characters that are not part of these sets
      sanitizedValue = sanitizedValue.replace(/[^\u0000-\u007F]+/g, "");
    }

    if (!readOnly) {
      sanitizedValue = sanitizedValue.replace(/[\r\n]/g, "").trimStart();
    }

    // Remove spaces for email fields
    if (name === "email") {
      sanitizedValue = sanitizedValue.replace(/\s/g, "");
    }

    // Prevent unnecessary updates that might override spaces
    if (sanitizedValue !== value) {
      event.target.value = sanitizedValue;
    }

    // Update the state with the sanitized value
    setInputValue(sanitizedValue);
  };
  const localOnChange = (e) => {
    handleInputChange(e);
    onChange(e);
  };

  const getError = () => {
    const isOptional =
      input.required === false || input.required === 0;
    const isEmpty = (fields[name] ?? "").toString().trim() === "";
    const isAmountFirstLayout = layout === "amount-first";

    if (isAmountFirstLayout && isOptional && isEmpty) {
      return null;
    }

    if (required.includes(name) && errors[name]) {
      return errors[name];
    }

    // If the field is not required and it's empty, don't show an error
    if (!required.includes(name) && isEmpty) {
      return null;
    }

    return errors[name] ? errors[name] : null;
  };

  const getPlaceholder = () => {
    if (input?.placeholder) {
      return langBack(input.placeholder);
    } else if (cashier_theme !== "power-slide") {
      return layout === "amount-first"
        ? (label ? langBack(label) : name)
        : langBack(label);
    } else {
      return "";
    }
  };

  const displayTitle =
    layout === "amount-first"
      ? (label ? langBack(label, true) : name)
      : langBack(label, true);
  return (
    <InputWrapper
      fieldType={fieldType}
      title={displayTitle}
      error={getError()}
      name={name}
      icon={
        icon?.props
          ? {
            ...icon,
            props: { ...icon.props, handleInputChange: setInputValue },
          }
          : icon
      }
    >
      <input
        onClick={() =>
          typeof onClick === "function" && !readOnly ? onClick() : false
        }
        className={`${s("input")} ${readOnly ? s("read-only") : ""}`}
        value={inputValue}
        name={name}
        required={required.includes(name)}
        readOnly={readOnly}
        disabled={readOnly}
        placeholder={getPlaceholder()}
        onBlur={onBlur}
        onFocus={() => onFocus(name)}
        onChange={localOnChange}
        type="text"
        ref={inputEl}
        data-additional-field-type={type}
      />
    </InputWrapper>
  );
};

export default CreateInputText;
